import type { ReactNode } from 'react';

export const symbol_image_arrow_up: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-480ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h364q13 0 21.5 8.5T574-810q0 13-8.5 21.5T544-780H180v600h600v-318q0-13 8.5-21.5T810-528q13 0 21.5 8.5T840-498v318q0 24-18 42t-42 18H180Zm564-645-53 53q-9 8-21 8t-21-9q-9-9-9-21t9-21l104-103q5-5 10-7t11-2q6 0 11.5 2t10.5 7l103 103q9 9 9 21.5t-9 21.5q-9 9-21 8.5t-21-8.5l-53-53v151q0 13-8.5 21.5T774-584q-13 0-21.5-8.5T744-614v-151ZM266-277h429q9 0 13-8t-1-16L590-457q-5-6-12-6t-12 6L446-302l-81-111q-5-6-12-6t-12 6l-86 112q-6 8-2 16t13 8Z"
		/>
	</svg>
);
